import { ListItemIcon, ListItemText } from '@mui/material';

import { AvailableTenant } from '../../types';
import { MenuItemReadonly, TenantIcon } from './styled';

export default function TenantOptionReadonly({ tenant, bold }: { tenant: AvailableTenant, bold?: boolean }) {
    return (
        <MenuItemReadonly disabled>
            <ListItemIcon>
                <TenantIcon src={ tenant.logoMarkUri } 
                    alt={ tenant.name }>
                </TenantIcon>
            </ListItemIcon>
            <ListItemText primary={ tenant.name }
                slotProps={{ 
                    primary: bold ? { style: { fontWeight: 'bold' } } : undefined
                }} />
        </MenuItemReadonly>
    );
}
